
const GraphQLQuery = require('app/graphql/Query');
const AutocompleteList = require('app/ui/list/Autocomplete');

const RangeSelect = require('app/ui/form/RangeSelect');
const SupplierSelect = require('app/ui/form/SupplierSelect');

class FormFactory {
    defaultOptions() {
        return {
            'units': [],

            'autocompleteTriggerMinLength': 3,
            'nbAutocompleteResult': 10,
            'onCancel': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickResetLink = this.onClickResetLink.bind(this);
        this.onReferenceAutocomplete = this.onReferenceAutocomplete.bind(this);
        this.onClickUnlinkProduct = this.onClickUnlinkProduct.bind(this);

        this.typingTimer=null;

        this.productAssociation = this.settings.productAssociation;
        this.units = this.settings.units;

        this.initialize();
    }

    initialize() {
        var self = this;


        this.mode = 'temp';

        this.id = null;
        this.reference = '';
        this.prospectProduct = null;
        this.linkedProduct = null;
        this.linkedProductId = '';
        this.linkedProductLabel = '';
        this.linkedProductSupplierId = '';
        this.linkedProductRangeId = '';
        this.productUnit = '';
        this.productQuantity = '';
        this.quantity = '';
        this.price = '';

        
        if(this.productAssociation){
            this.mode='create';
            if(this.productAssociation.id){
                this.id = this.productAssociation.id;
                this.mode = 'edit';
                this.prospectProduct = this.productAssociation.product;
                if(this.prospectProduct && this.prospectProduct.id){
                    this.reference = this.prospectProduct.reference;
                    this.linkedProduct = this.prospectProduct.product;
                    this.productUnit = this.prospectProduct.unit;
                    this.productQuantity = this.prospectProduct.quantity;

                    if(this.linkedProduct && this.linkedProduct.id){
                        this.linkedProductId = this.linkedProduct.id;

                        this.linkedProductSupplier = this.linkedProduct.supplier;
                        this.linkedProductLabel = this.linkedProduct.reference;

                        this.linkedProductSupplierId = this.linkedProductSupplier.id;
                        this.linkedProductRangeId = this.linkedProduct.range.id;
                    }
                }
                this.quantity = this.productAssociation.quantity;
                this.price = this.productAssociation.price;
            }
        }
    }

    fillForm($form){
        this.$form = $form;
        this.buildForm();
    }


    buildForm(){
        var self = this;

        this.$inputReference = $('<input/>')
        .attr('id','reference')
        .attr('type','text')
        .attr('name','reference')
        .addClass('form-control')
        .attr('required','required')
        .val(this.reference);

        let $referenceContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','reference')
            .append(window.translate('restaurant.product.reference.label'))
        )
        .append(this.$inputReference)

        if(this.mode != 'edit'){
            this.$inputReference
            .on('keydown',this.onReferenceAutocomplete)
            .on('keyup',this.onReferenceAutocomplete);
        }

        this.$inputQuantity = $('<input/>')
        .attr('id','quantity')
        .attr('type','text')
        .attr('name','quantity')
        .addClass('form-control')
        .attr('required','required')
        .val(this.quantity);


        this.$inputHiddenLinkedProduct = $('<input/>')
        .attr('type','hidden')
        .attr('name','linkedProduct')
        .val(this.linkedProductId);

        let $btnResetLink = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-link text-dark')
        .attr('title',"Restaurer le lien")
        .append(
            $('<i/>')
            .addClass('fa fa-undo')
        )
        .on('click',this.onClickResetLink);


        this.$selectRange = $('<select/>')
        .attr('name','range')
        .addClass('form-control');

        this.rangeSelectObject = new RangeSelect({
            '$select': this.$selectRange,
            'onChange': this.onReferenceAutocomplete,
            'value': this.linkedProductRangeId

        });

        let $rangeSelectContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','range')
            .append(window.translate('app.product.show.tabs.info.infoForm.range.label'))
        )
        .append(
            $('<div/>')
            .addClass('input-group')
            .append(this.$selectRange)
        )

        this.$selectSupplier = $('<select/>')
        .attr('name','supplier')
        .addClass('form-control');

        this.supplierSelectObject = new SupplierSelect({
            '$select': this.$selectSupplier,
            'onChange': this.onReferenceAutocomplete,
            'value': this.linkedProductSupplierId
        });

        let $supplierSelectContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','supplier')
            .append(window.translate('app.product.show.tabs.info.infoForm.supplier.label'))
        )
        .append(
            $('<div/>')
            .addClass('input-group')
            .append(this.$selectSupplier)
        );

        this.$inputLinkedReference = $('<input/>')
        .attr('type','text')
        .attr('id','linkedProductLabel')
        .attr('name','linkedProductLabel')
        .addClass('form-control')
        .attr('placeholder',"Aucun produit lié")
        .attr('aria-describedby','referenceHelper')
        .attr('data-default-id',this.linkedProductId)
        .attr('data-default-label',this.linkedProductLabel)
        .val(this.linkedProductLabel)
        .on('keydown',this.onReferenceAutocomplete)
        .on('keyup',this.onReferenceAutocomplete);

        this.$selectProductContainer = $('<div/>')
        .hide();

        this.$btnUnlink = $('<span/>')
        .attr('title',window.translate('app.restaurant.show.tabs.analyse.product.reference.unlink'))
        .append(
            $('<i/>')
            .addClass('fa fa-unlink')
        )
        .on('click',this.onClickUnlinkProduct);
        if(this.linkedProductId == 0){
            $btnResetLink.hide();
        }

        let $linkedProductContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','linkedProductLabel')
            .append(window.translate('restaurant.product.reference.label'))
        )
        .append(
            $('<div/>')
            .addClass('input-group')
            .append(this.$inputLinkedReference)
            .append(
                $("<span/>")
                .addClass('input-group-text')
                .addClass('bg-dark border-dark text-white')
                .css('cursor','pointer')
                .append(this.$btnUnlink)
            )
        );

        if(!this.linkedProductId){
            this.$btnUnlink.parent().hide();
        }

        this.$inputPrice = $('<input/>')
        .attr('id','price')
        .attr('type','text')
        .attr('name','price')
        .addClass('form-control')
        .attr('required','required')
        .val(this.price);
        this.$priceHelper = $('<div/>')
        .attr('id','priceHelper')
        .addClass('form-text');

        let $priceContainer =$('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','price')
            .append(window.translate('restaurant.prospect.invoice.price.label'))
        )
        .append(this.$inputPrice)
        .append(this.$priceHelper);

        this.$inputQuantity = $('<input/>')
        .attr('id','quantity')
        .attr('type','text')
        .attr('name','quantity')
        .addClass('form-control')
        .attr('required','required')
        .val(this.quantity);

        let $quantityContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','quantity')
            .append(window.translate('restaurant.prospect.invoice.quantity.label'))
        )
        .append(this.$inputQuantity);

        this.$selectProductUnit = $('<select/>')
        .attr('type','text')
        .attr('id','productUnit')
        .attr('name','productUnit')
        .attr('required',"required")
        .addClass('form-control')
        .append(
            $('<option/>').val('').append('')
        );

        for(var i in this.units){
            let unit = this.units[i];

            let $option = $('<option/>')
            .val(unit.value)
            .append(unit.label);
            if(unit.value == this.productUnit){
                $option.prop('selected',true);
            }
            this.$selectProductUnit.append($option);
        }

        let $unitContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','productUnit')
            .append(window.translate('restaurant.prospect.product.unit.label'))
        )
        .append(this.$selectProductUnit);

        this.$inputProductQuantity = $('<input/>')
        .attr('type','text')
        .attr('id','productQuantity')
        .attr('name','productQuantity')
        .attr('required',"required")
        .addClass('form-control')
        .val(this.productQuantity);

        let $productQuantityContainer = $('<div/>')
        .addClass('form-group p-2')
        .append(
            $('<label/>')
            .attr('for','productQuantity')
            .append(window.translate('restaurant.prospect.product.packaging.label'))
        )
        .append(this.$inputProductQuantity);


        this.$form
        .append(this.$inputHiddenLinkedProduct)
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-5')
                .append($referenceContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-1')
                .append($unitContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-2')
                .append($productQuantityContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-2')
                .append($quantityContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-2')
                .append($priceContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('bg-green-restofute text-white rounded p-2')
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(
                    $('<label/>')
                    .attr('for','linkedProduct')
                    .append(window.translate('restaurant.prospect.product.related.label'))
                    .append(" <strong>"+this.linkedProductLabel+"</strong> ")
                    .append($btnResetLink)
                )
            )
            .append(
                $('<div/>')
                .addClass('row')
                .append(    
                    $('<div/>')
                    .addClass('col-3')
                    .append($rangeSelectContainer)
                )
                .append(        
                    $('<div/>')
                    .addClass('col-3')
                    .append($supplierSelectContainer)
                )
                .append(
                    $('<div/>')
                    .addClass('col-6')
                    .append($linkedProductContainer)
                )
            )
            .append(
                $('<div/>')
                .addClass('row')
                .append(
                    $('<div/>')
                    .addClass('col-12 p-2')
                    .append(this.$selectProductContainer)
                )
            )
        );

        return this.$form;
    }


    onClickUnlinkProduct(){
        this.unlinkProduct();
    }

    unlinkProduct(dontResetLabel){
        this.$inputHiddenLinkedProduct.val(0);
        this.$inputLinkedReference.val('');
        this.$selectProductContainer.html('');

        this.$selectRange.val('');
        this.$selectSupplier.val('');
        this.$btnUnlink.parent().hide();
    }


    onReferenceAutocomplete(event){
        var self = this;
        let typingInterval = 500;
        if(this.typingTimer){
            clearTimeout(this.typingTimer);
        }
        this.typingTimer = setTimeout(
            function(){
                self.proceedAutocomplete();
            },
            typingInterval
        );
    }

    proceedAutocomplete(){
        this.$selectProductContainer.html('');

        let text = this.$inputLinkedReference.val();
        if(text == '' && this.mode != 'edit'){
            text = this.$inputReference.val();
        }
        if(text.length >= this.settings.autocompleteTriggerMinLength){
            this.searchProduct(text);
        }

    }

    searchProduct(text){
        var self = this;

        if(this.autocompleteQuery){
            this.autocompleteQuery.abort();
        }

        this.$selectProductContainer.html('')
        .append(window.App.generateLoader())
        .show();


        let parameters = {
            'first': this.settings.nbAutocompleteResult,
            'filter': {
                'reference': '%'+text+'%'
            },
            'orderBy': 'supplierPrice',
            'dir': 'ASC'
        };

        if(this.$selectRange.val()){
            parameters['filter']['rootRange'] = parseInt(this.$selectRange.val());
        }

        if(this.$selectSupplier.val()){
            parameters['filter']['supplier'] = parseInt(this.$selectSupplier.val());
        }

        let fields = [
            'id',
            'reference',
            'unit',
            'quantity',
            'price',
            'supplierPrice',
            'supplier { id name }',
            'range { id name parent { name } }',
        ];

        this.autocompleteQuery = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.showSearchProductResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        this.autocompleteQuery.execute();
    }

    showSearchProductResult(data){
        var self = this;
        this.$selectProductContainer.html('');
        let items = data.edges;

        this.autocompleteList = new AutocompleteList({
            '$container': this.$selectProductContainer,

            'listClass': 'restaurant-analyse-product-autocomplete-list',
            'listItemClass': 'restaurant-analyse-product-autocomplete-list-item',
            'messageNoItem': "Aucun résultat",
            'showNoItemMessage': true,

            'items': items,
            'renderItem': function(item,index){
                let $item = self.buildSearchProductResultItem(item.node);
                if(index == 0){
                    $item.addClass('highlighted');
                }
                return $item;
            },
            'onClickItem': function(item){ 
                return self.onClickProductResultItem(item.node);
            },
        });

    }

    clearSearchProductResult(){
        this.$selectProductContainer.html('');
    }

    buildSearchProductResultItem(product){
        var self = this;

        let reference = product.reference;
        let price = product.price;
        let quantity = product.quantity;
        let rangeName = product.range.name;
        let parentRangeName = product.range && product.range.parent ? product.range.parent.name : '';
        let supplierPrice = product.supplierPrice;
        let supplierName = product.supplier.name;
        let unit = product.unit;

        let parentRangeLabel = parentRangeName ? '('+parentRangeName+')' : '';

        let $content = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-4')
            .append(reference)
        )
        .append(
            $('<div/>')
            .addClass('col-4')
            .append(
                $('<div/>')
                .append(rangeName)
            )
            .append(
                $('<div/>')
                .append(parentRangeLabel)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(
                $('<div/>')
                .append(supplierName)
            )
            .append(
                $('<div/>')
                .append(window.formatFloat(quantity) + unit)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(
                $('<div/>')
                .append('P.A. : ' + window.formatFloat(supplierPrice) + ' &euro;')
            )
            .append(
                $('<div/>')
                .append('P.V. : ' + window.formatFloat(price) + ' &euro;')
            )
        )

        return $content;
    }

    onClickProductResultItem(product){
        this.clearSearchProductResult();
        this.$inputHiddenLinkedProduct.val(product.id);
        this.$btnUnlink.parent().show();

        let linkedProductLabel = window.htmldecode(product.reference);
        this.$inputLinkedReference.val(linkedProductLabel);

        if(this.mode!='edit'){
            this.$inputReference.val(linkedProductLabel);
        }

        this.$selectRange.val(product.range.id);
        this.$selectSupplier.val(product.supplier.id);

        if(!this.id){
            this.$inputProductQuantity.val(product.quantity);
            $('option[value="'+product.unit+'"]',this.$selectProductUnit).prop('selected',true);
        }

        this.$priceHelper
        .html('')
        .append('P.V. Restofuté : ' + this.getPriceByUnit(product.unit,product.quantity,product.price));
    }

    getPriceByUnit(unit,cond,price){

        let floatCond = parseFloat(cond);
        let floatPrice = parseFloat(price);

        if(floatCond <= 0){
            return 0;
        }

        let conditionnement = floatCond > 1 ? window.formatFloat(floatCond) + ' ' + unit : unit;
        return window.formatFloat(floatPrice)+' &euro; / '+ conditionnement;
    }

    onClickResetLink(event){
        event.preventDefault();
        event.stopPropagation();

        let id = this.$inputLinkedReference.data('default-id');
        let label = this.$inputLinkedReference.data('default-label');

        this.$inputHiddenLinkedProduct.val(id);
        this.$inputLinkedReference.val(label);

        if(id){
            this.$btnUnlink.parent().show();
        }else{
            this.$btnUnlink.parent().hide();
        }
    }
}

module.exports = FormFactory;

